import { APP_ROUTES } from '../../../app-routes';

/**
 * Two pages, deliberately: the services catalogue is settings-shaped (rare
 * writes, one row per thing the shop offers) and the bookings list is a
 * worklist. There is no `:id/edit` under either — a booking's service, time,
 * customer and price are snapshotted, so the API has no edit endpoint at all.
 */
export const BOOKINGS_ROUTES = {
  Detail: ':id'
};

const BASE = APP_ROUTES.Bookings;

export const BookingsPaths = {
  Base: `/${BASE}`,
  Detail: (id: string) =>
    `/${BASE}/${BOOKINGS_ROUTES.Detail.replace(':id', id)}`
};

export const BookableServicesPaths = {
  Base: `/${APP_ROUTES.BookableServices}`
};
